<template>
    <template v-if="isAdmin">
        <VJoyButton class="profile-admin-wrapper__admin-panel-button" size="small" variant="admin" @click="eventBus.emit('dev-tools:edit-mode')">
            Admin
        </VJoyButton>
        <AdminPanelSection />
        <VettingPanelSection :profile="profile as Profile" :wrapper-ref="scrollWrapper" />
    </template>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {toRef, useHasEnoughPriviledge} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import AdminPanelSection from '~/components/edit/AdminPanelSection.vue';
    import VettingPanelSection from '~/components/edit/VettingPanelSection.vue';
    import {eventBus} from '~/config/events';
    import {useProfileStore} from '~/store/profileStore';
    import {type Profile} from '~/types/domain/Profile';

    type LazyAdminComponentsProps = {
        refToScrollTarget: HTMLElement | null;
    };

    const props = defineProps<LazyAdminComponentsProps>();

    const isAdmin = await useHasEnoughPriviledge(['ROLE_ADMIN']);

    const profileStore = useProfileStore();
    const {profile} = storeToRefs(profileStore);
    const scrollWrapper = toRef(props, 'refToScrollTarget');
</script>
<style lang="scss">
    .profile-admin-wrapper {
        &__admin-panel-button {
            &.joy-button {
                position: fixed;
                top: calc(var(--header-height) + var(--joy-core-spacing-5));
                right: var(--joy-core-spacing-5);
                z-index: 10;
            }
        }
    }
</style>
